import React, { useMemo } from "react";
import "scss/main-layout.scss";
import DynataLogo from "core/widgets/dynataLogo";
import { Outlet, useNavigate } from "react-router-dom";
import { FaBullhorn, FaRightLeft, FaToriiGate } from "react-icons/fa6";
import { HiRectangleStack } from "react-icons/hi2";
import CustomMenu from "../widgets/customMenu.widget";
import { AdminMenuItems, createMenuItems, MenuItems } from "./index";
import paths from "paths";
import { AuthActionTypes, useStateContext, useStateDispatcher } from "state";
import { Navbar, NavDropdown, NavItem } from "core/components/nav-bar";

const docItem = [
  {
    title: "REX",
    icon: FaRightLeft,
    className: "text-large text-primary-dynata-dark",
    onClick: () => {
      window.open("https://docs.rex.dynata.com", "_blank")?.focus();
    },
  },
  {
    title: "Respondent Gateway",
    icon: FaToriiGate,
    className: "text-large text-primary-dynata-dark",
    onClick: () => {
      window
        .open("https://docs.rex.dynata.com/gateway/overview/", "_blank")
        ?.focus();
    },
  },

  {
    title: "Opportunity Registry",
    icon: HiRectangleStack,
    className: "text-large text-primary-dynata-dark",
    onClick: () => {
      window.open("https://docs.rex.dynata.com/registry/overview/")?.focus();
    },
  },
  {
    title: "Respondent Event Broadcaster",
    icon: FaBullhorn,
    className: "text-large text-primary-dynata-dark",
    onClick: () => {
      window
        .open("https://docs.rex.dynata.com/broadcaster/", "_blank")
        ?.focus();
    },
  },
];

const hiddenNavbarPaths = [`/${paths.admin.MANAGE_USERS}`];

export const MainLayout: React.FC = () => {
  const navigate = useNavigate();
  const shouldHideNavbar = hiddenNavbarPaths.includes(location.pathname);
  const dispatcher = useStateDispatcher();
  const state = useStateContext();

  const logout = () => {
    dispatcher({ type: AuthActionTypes.LOGOUT });
    navigate(`/${paths.open.LOGIN}`);
  };

  const menuItems = useMemo(() => {
    let menu = createMenuItems(MenuItems, navigate, logout);
    if (state.user?.isAdmin) {
      menu.splice(1, 0, ...createMenuItems(AdminMenuItems, navigate, () => {}));
    }
    return menu;
  }, [state.user, navigate]);

  return (
    <div className="main-layout">
      {!shouldHideNavbar && (
        <Navbar
          logo={
            <div style={{ width: "100px" }}>
              <DynataLogo />
            </div>
          }
          assistiveToolbar={
            <CustomMenu
              title={state.user?.username}
              subtitle={
                state.user?.roles?.length! > 1
                  ? state.user?.organizationName
                  : state.user?.roles[0]?.accountName
              }
              menuItems={menuItems}
            />
          }
        >
          {state.user?.isSingleAdHocAccount ? (
            <NavItem
              title="Projects"
              to={paths.authenticated.PROJECTS}
            />
          ) : (
            <NavItem
              title="Dashboard"
              to={paths.authenticated.DASHBOARD}
            />
          )}
          {state.user && state.user.roles.length > 1 && (
            <NavItem
              title="Accounts"
              to={paths.authenticated.USER_ACCOUNTS}
            />
          )}
          {/* state.user &&
            state.user.roles.length === 1 &&
            !state.user.roles[0].isAdhoc && (
              <NavItem
                id={`${reactId}-reports`}
                title="Reports"
                onClick={() => navigate(paths.authenticated.REPORTS)}
              />
            ) */}
          <NavDropdown
            title="Documentation"
            items={docItem}
          />
        </Navbar>
      )}
      <Outlet />
    </div>
  );
};
